import { Menu as BaseMenu } from '@base-ui/react/menu'

import { cn } from '@gto/ui/cn'

import { menuItemVariants } from './item.styles'

type ItemProps = BaseMenu.Item.Props & {
  /**
   * Paints the row with the primary tint to signal a persistent active
   * choice (e.g. a submenu item that matches the current value). Distinct
   * from the transient `data-[highlighted]` hover/focus state.
   */
  selected?: boolean
}

export const Item = ({ className, selected, ...props }: ItemProps) => {
  return (
    <BaseMenu.Item
      className={cn(menuItemVariants(), className)}
      data-selected={selected === true ? '' : undefined}
      {...props}
    />
  )
}
